import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { Box, Button, Center, Flex, IconButton, Portal } from '@chakra-ui/react';
import { Svg } from '../Svg';
import { DialogWindow } from './components';
const VARIANT_STYLES = {
    compactGray: {
        bg: 'bg',
        titlePadding: '0',
        titleFontSize: '16px',
        buttonSize: 'xs',
        buttonMinWidth: '0',
        buttonsGap: '8px',
        buttonsMargin: '12px 0 0 0',
        buttonsPadding: '12px 0 2px',
        buttonsDividerBorder: '1px solid'
    },
    mediumWhite: {
        bg: 'white',
        titlePadding: '28px 56px 20px 56px',
        titleFontSize: '24px',
        buttonSize: 'md',
        buttonMinWidth: '145px',
        buttonsGap: '20px',
        buttonsMargin: '0',
        buttonsPadding: '32px 56px 30px 0',
        buttonsDividerBorder: '0 solid'
    }
};
const DialogFC = ({ title, variant = 'compactGray', isButtonsDisabled, children, isFloating, minWidth, floatMinWidth, onlyTitlePadding, noOverflow, buttons, onClose }) => {
    const [isFloat, setIsFloat] = useState(false);
    const [isWaiting, setIsWaiting] = useState(false);
    const styles = VARIANT_STYLES[variant];
    const handleToggleFloat = useCallback(() => {
        setIsFloat((prev) => !prev);
    }, []);
    const handleApply = useCallback(async () => {
        setIsWaiting(true);
        await buttons?.apply?.onClick?.();
        setIsWaiting(false);
        onClose?.();
    }, [buttons?.apply, onClose]);
    const handleClose = useCallback(async () => {
        await buttons?.close?.onClick?.();
        onClose?.();
    }, [buttons?.close, onClose]);
    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key.toLowerCase() === 'enter') {
                handleApply();
            }
            else if (e.key.toLowerCase() === 'escape') {
                handleClose();
            }
        };
        window.addEventListener('keydown', handleKeyDown, true);
        return () => {
            window.removeEventListener('keydown', handleKeyDown, true);
        };
    }, [handleApply, handleClose]);
    const renderChildren = () => (_jsxs(Flex, { direction: "column", w: "100%", children: [_jsx(Box, { children: children }), !!buttons && (_jsxs(Flex, { m: styles.buttonsMargin, p: styles.buttonsPadding, gap: styles.buttonsGap, borderTop: styles.buttonsDividerBorder, borderColor: "border", justifyContent: "flex-end", children: [!!buttons?.close && (_jsx(Button, { variant: "ghost", size: styles.buttonSize, minW: styles.buttonMinWidth, isDisabled: buttons.close.isDisabled || isButtonsDisabled, onClick: handleClose, children: buttons.close.title })), !!buttons?.apply && (_jsx(Button, { size: styles.buttonSize, minW: styles.buttonMinWidth, isDisabled: (buttons.apply.isDisabled ?? isWaiting) || isButtonsDisabled, variant: buttons.apply.isDanger ? 'danger' : 'solid', onClick: handleApply, children: buttons.apply.title }))] }))] }));
    if (isFloat) {
        return (_jsx(Portal, { children: _jsx(DialogWindow, { right: "0", bottom: "0", zIndex: 10, 
                // @ts-ignore
                title: title, position: "absolute", maxW: "30%", minW: floatMinWidth, noOverflow: noOverflow, onlyTitlePadding: onlyTitlePadding, titleSx: {
                    padding: styles.titlePadding,
                    fontSize: styles.titleFontSize
                }, onClose: onClose, actionElement: isFloating ? (_jsx(IconButton, { size: "smSquare", "aria-label": "", variant: "ghostTr", icon: _jsx(Svg, { size: "s12", name: "Max" }), onClick: handleToggleFloat })) : undefined, children: renderChildren() }) }));
    }
    return (_jsx(Portal, { children: _jsx(Box, { top: "0", left: "0", right: "0", bottom: "0", zIndex: 10, position: "absolute", bg: "rgba(255, 255, 255, 0.5)", children: _jsx(Center, { h: "100%", w: "100%", children: _jsx(DialogWindow, { maxW: "80%", minW: minWidth, maxH: "calc(100vh - 40px)", noOverflow: noOverflow, onlyTitlePadding: onlyTitlePadding, bg: styles.bg, 
                    // @ts-ignore
                    title: title, titleSx: {
                        padding: styles.titlePadding,
                        fontSize: styles.titleFontSize
                    }, onClose: onClose, actionElement: isFloating ? (_jsx(IconButton, { size: "smSquare", "aria-label": "", variant: "ghostTr", icon: _jsx(Svg, { size: "s12", name: "Min" }), onClick: handleToggleFloat })) : undefined, children: renderChildren() }) }) }) }));
};
export const Dialog = DialogFC;
//# sourceMappingURL=Dialog.js.map